import { useEffect, useState } from 'react'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiFlexGroup,
	EuiFlexItem,
	EuiPage,
	EuiPageBody,
	EuiPageSection,
	EuiPagination,
	EuiPanel,
} from '@equipmentshare/ds2'

import StyledHeader from '../../components/StyledHeader'
import SearchBar from '../../components/SearchBar'
import RefreshButton from '../../components/RefreshButton'
import Table from '../../components/Table'
import PageTitle from 'views/components/PageTitle/PageTitle'

import { useProvidersQuery } from '../../../graphql'
import columns from './columns'
import { getAddModal } from './components/actionModals'
import { useDispatchSetSelectedModal } from 'contexts/modal-context/modal-context'
import { TABLE_HEIGHT } from '../../helpers/utils'

export default function Providers(): JSX.Element {
	const paginationSize = 40
	const [ activePage, setActivePage ] = useState( 0 )
	const [ search, setSearch ] = useState( '' )
	const { loading, data, refetch } = useProvidersQuery( {
		variables: {
			names: [ search ],
			size: paginationSize,
			offset: activePage * paginationSize,
		}
	} )
	const setSelectedModal = useDispatchSetSelectedModal()
	const onAddClick = () => {
		heapEvent( 'Inventory - Manufacturer Catalog - Click - Add Manufacturer', {} )
		setSelectedModal( getAddModal() )
	}

	// Set back to first page
	useEffect( () => {
		setActivePage( 0 )
	}, [ search ] )// any change EXCEPT for activePage, offset, size
	// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
	const showPagination = ( !loading && !!( data?.providers?.length || activePage > 0 ) )

	const getNoItemsMessage = () => {
		if ( loading ) {
			return 'Loading data'
		}
		if ( data?.providers?.length === 0 && activePage > 0 ) {
			return 'No more records'
		}

		return 'No records found'
	}

	const onSearchChange = ( s: string ) => {
		heapEvent( 'Inventory - Manufacturer Catalog - Change - Search Input', { search_term: s } )
		setSearch( s )
	}

	const fullHeight = 'eui-fullHeight'

	return (
		<EuiPage paddingSize="l">
			<EuiPageBody className={fullHeight}>
				<PageTitle title="Manufacturer Catalog" />
				<StyledHeader>
					<EuiFlexGroup wrap>
						<EuiFlexItem style={{ minWidth: 677 }}>
							<div className="content searchFilter">
								<SearchBar search={search} setSearch={onSearchChange} />
								<RefreshButton refetchFunction={refetch} />
							</div>
						</EuiFlexItem>
						<EuiFlexItem grow={false}>
							<div className="content actions">
								<EuiButton
									fill
									onClick={onAddClick}
								>
									Add manufacturer
								</EuiButton>
							</div>
						</EuiFlexItem>
					</EuiFlexGroup>
				</StyledHeader>

				<EuiPageSection className={fullHeight} paddingSize="none">
					<EuiPanel paddingSize="none" className="eui-yScroll" hasShadow={false} style={{ height: TABLE_HEIGHT }}>
						<Table
							isLoading={loading}
							emptyStateText={getNoItemsMessage()}
							columns={columns}
							rows={data?.providers}
						/>
					</EuiPanel>

					{ showPagination && (
						<EuiFlexGroup justifyContent="flexEnd">
							<EuiFlexItem grow={false}>
								<EuiPagination
									pageCount={0}
									activePage={activePage}
									onPageClick={( ap ) => setActivePage( ap )}
								/>
							</EuiFlexItem>
						</EuiFlexGroup>
					) }

				</EuiPageSection>
			</EuiPageBody>
		</EuiPage>
	)
}
